var map = {
	"./Dark Loop.mp3": 8449,
	"./Dark Synth.mp3": 5275,
	"./Dramatic Strings.mp3": 8548,
	"./Electro-Wave Crusher.mp3": 7043,
	"./Failure Music 1.mp3": 549,
	"./Success Music 1.mp3": 7914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3759;